import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SessionStorageService {

    set(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    get<T>(key: string): T | null {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }

    remove(key: string): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }
}
